const app = {
  carouselContainerEl: '#topCarouselContainerEl',
  carouselMountEl: '#topCarouselMountEl',
  sidebarMountEl: '#topSidebarMountEl',
  articleMountEl: '#topArticleMountEl',
  topSearchMountEl: '#topSearchMountEl',
  topMainMountEl:  '#topMainMountEl',
  topSideBarMountEl: '#topPageSidebar',
  ieDeprecatedAlertEl: '#topIEDeprecatedAlertEl'
}

const data = {
  carouselContents: '#json-carousel-contents',
  brandItems: '#json-top-brands-contents',
  productCategories: '#jsonProductCategories',
  articles: '#json-article-contents',
  announcements: '#json-announcements',
  viewedProducts: '#viewed-products',
  flagTopSearch: '#flag-top-search',
  maxQuantityPrice : '#maxQuantityPrice',
  topProducts: '#json-product-groups-top-page'
}

export { app, data }
